import { createSlice } from '@reduxjs/toolkit';
import { ALL_FIELDS_FLAT, FIELD_GROUPS } from './exportReportConstants.js';

const initialState = {
  step: 1,
  showGuide: false,
  showMatchSelection: false,
  potentialMatches: [],
  rawSearchResults: [],
  tempSelectedMatches: [],
  filters: {
    provider: '',
    collector: '',
    hearingStartDate: '',
    hearingEndDate: '',
    isSettled: false,
    isOffer: false,
  },
  activeSections: {
    provider: false,
    collector: false,
    hearing: false,
  },
  isFilterDirty: false,
  uniqueProviders: [],
  providersLoading: false,
  filterIntent: 'append',
  loading: false,
  foundRecords: [],
  lastFilterSummary: '',
  selectedFields: ALL_FIELDS_FLAT.map((f) => f.key),
  selectedRecordIds: [],
  expandedGroups: Object.keys(FIELD_GROUPS),
  modalConfig: {
    isOpen: false,
    title: '',
    message: '',
    confirmText: 'Confirm',
    isDanger: false,
    actionType: null,
    actionPayload: null,
  },
};

const exportReportSlice = createSlice({
  name: 'exportReport',
  initialState,
  reducers: {
    setStep(state, action) {
      state.step = action.payload;
    },
    setShowGuide(state, action) {
      state.showGuide = action.payload;
    },
    setShowMatchSelection(state, action) {
      state.showMatchSelection = action.payload;
    },
    setPotentialMatches(state, action) {
      state.potentialMatches = action.payload;
    },
    setRawSearchResults(state, action) {
      state.rawSearchResults = action.payload;
    },
    setTempSelectedMatches(state, action) {
      state.tempSelectedMatches = action.payload;
    },
    setFilters(state, action) {
      state.filters = action.payload;
    },
    updateFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    setActiveSections(state, action) {
      state.activeSections = action.payload;
    },
    updateActiveSections(state, action) {
      state.activeSections = { ...state.activeSections, ...action.payload };
    },
    setIsFilterDirty(state, action) {
      state.isFilterDirty = action.payload;
    },
    setUniqueProviders(state, action) {
      state.uniqueProviders = action.payload;
    },
    setProvidersLoading(state, action) {
      state.providersLoading = action.payload;
    },
    setFilterIntent(state, action) {
      state.filterIntent = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setFoundRecords(state, action) {
      state.foundRecords = action.payload;
    },
    setLastFilterSummary(state, action) {
      state.lastFilterSummary = action.payload;
    },
    setSelectedFields(state, action) {
      state.selectedFields = action.payload;
    },
    setSelectedRecordIds(state, action) {
      state.selectedRecordIds = action.payload;
    },
    setExpandedGroups(state, action) {
      state.expandedGroups = action.payload;
    },
    setModalConfig(state, action) {
      state.modalConfig = { ...state.modalConfig, ...action.payload };
    },
    resetExportReport() {
      return initialState;
    },
  },
});

export const {
  setStep,
  setShowGuide,
  setShowMatchSelection,
  setPotentialMatches,
  setRawSearchResults,
  setTempSelectedMatches,
  setFilters,
  updateFilters,
  setActiveSections,
  updateActiveSections,
  setIsFilterDirty,
  setUniqueProviders,
  setProvidersLoading,
  setFilterIntent,
  setLoading,
  setFoundRecords,
  setLastFilterSummary,
  setSelectedFields,
  setSelectedRecordIds,
  setExpandedGroups,
  setModalConfig,
  resetExportReport,
} = exportReportSlice.actions;

export const selectExportReport = (state) => state.exportReport;

export default exportReportSlice.reducer;
